/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useRef } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { DialogContent, DialogContentText } from "@mui/material";
import Button from "../../../component/button";
import { withTranslation, Trans } from "react-i18next";
import Draggable from "react-draggable";
import { Paper } from "@mui/material";
import { Tooltip, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";

const SuspendDialog = (props) => {
  return (
    <Dialog
      disableScrollLock={true}
      open={props.isOpen}
      PaperComponent={DraggableDialogPaper}
      fullWidth={true}
      maxWidth={"sm"}
    >
      <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
        <div style={{ display: "flex" }}>
          <span style={{ display: "inline-flex", width: "95%" }}>
            {props.action === "SUSPEND" && props.t("SUSPEND_SUBSCRIPTION")}
            {props.action === "RESUME" && props.t("RESUME_SUBSCRIPTION")}
            {props.action === "CHANGE" && props.t("TAKEOVER_SUBSCRIPTION")}
            {props.action === "SHIFT" && props.t("SHIFT_SUBSCRIPTION")}
          </span>
          <Tooltip title={props.t("CLOSE")}>
            <IconButton
              onTouchStart={() => props.close(false)}
              onClick={() => props.close(false)}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </div>
      </DialogTitle>
      <DialogContent dividers>
        <DialogContentText>
          {/* {props.action === 'SUSPEND' && props.t('SUSPEND_SUBSCRIPTION_CONFIRMATION_MESSAGE')}
                    {props.action === 'RESUME' && props.t('RESUME_SUBSCRIPTION_CONFIRMATION_MESSAGE')}
                    {props.action === 'CHANGE' && props.t('TAKEOVER_SUBSCRIPTION_CONFIRMATION_MESSAGE')}
                    {props.action === 'SHIFT' && props.t('DO_YOU_WANT_TO_CONTINUE')} */}
          {props.action === "SUSPEND" ? (
            <>
              {props.t("SUSPEND_SUBSCRIPTION_CONFIRMATION_MESSAGE")}
              <FormControl
                variant="outlined"
                size={"small"}
                style={{
                  display: "inline",
                  marginLeft: "10px",
                  marginRight: "10px",
                }}
              >
                {/* <InputLabel id="inventoryItemType">
                                    {props.t('DURATION') + ' *'}</InputLabel> */}
                <Select
                  //disabled={props.mode === 'edit'}
                  value={props.months}
                  native
                  // label="Duration *"
                  labelId="inventoryItemType"
                  onChange={(event) => props.onChangeMonths(event)}
                  inputProps={{
                    name: "months",
                  }}
                  style={{ width: "60px" }}
                >
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                </Select>
              </FormControl>
              months?
            </>
          ) : (
            <>{props.t("DO_YOU_WANT_TO_CONTINUE")}</>
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            props.close(false);
          }}
        >
          {props.t("NO")}
        </Button>
        <Button
          onClick={() => {
            props.close(true);
          }}
        >
          {props.t("YES")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const DraggableDialogPaper = (props) => {
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      bounds={"parent"}
      defaultClassName="customReactDraggableComponent"
      handle="#draggableDialogPaper"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
};

export default withTranslation("translations")(SuspendDialog);
